"use strict";

require("core-js/modules/es.object.keys.js");

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.array.filter.js");

require("core-js/modules/es.object.get-own-property-descriptor.js");

require("core-js/modules/es.array.for-each.js");

require("core-js/modules/web.dom-collections.for-each.js");

require("core-js/modules/es.object.get-own-property-descriptors.js");

require("core-js/modules/es.object.define-properties.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.rocheThemeOptions = void 0;

require("core-js/modules/es.object.define-property.js");

var _utils = require("../utils");

var _theme = require("./theme.utils");

var _theme2 = require("./theme.fonts");

var _grey;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var typographyMixin = {
  fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif"
};
var baseColor = {
  primaryMain: '#0066cc',
  // rgb(0,102,204)
  primaryAlt: '#a5d2ff',
  // rgb(165,210,255)
  secondaryMain: '#00925b',
  // rgb(0,146,91)
  secondaryAlt: '#80c4aa' // rgb(128,196,170)

};
var rocheThemeOptions = {
  typography: {
    h1: _objectSpread(_objectSpread({}, typographyMixin), {}, {
      fontWeight: 300,
      fontSize: '96px',
      lineHeight: '134px',
      letterSpacing: '0em'
    }),
    h2: _objectSpread(_objectSpread({}, typographyMixin), {}, {
      fontWeight: 300,
      fontSize: '60px',
      lineHeight: '84px',
      letterSpacing: '0em'
    }),
    h3: _objectSpread(_objectSpread({}, typographyMixin), {}, {
      fontWeight: 400,
      fontSize: '48px',
      lineHeight: '67px',
      letterSpacing: '0em'
    }),
    h4: _objectSpread(_objectSpread({}, typographyMixin), {}, {
      fontWeight: 400,
      fontSize: '34px',
      lineHeight: '48px',
      letterSpacing: '0.007em'
    }),
    h5: _objectSpread(_objectSpread({}, typographyMixin), {}, {
      fontWeight: 400,
      fontSize: '24px',
      lineHeight: '34px',
      letterSpacing: '0em'
    }),
    h6: _objectSpread(_objectSpread({}, typographyMixin), {}, {
      fontWeight: 500,
      fontSize: '20px',
      lineHeight: '30px',
      letterSpacing: '0em'
    }),
    body1: _objectSpread(_objectSpread({}, typographyMixin), {}, {
      fontWeight: 400,
      fontSize: '16px',
      lineHeight: '23px',
      letterSpacing: '0em'
    }),
    body2: _objectSpread(_objectSpread({}, typographyMixin), {}, {
      fontWeight: 400,
      fontSize: '14px',
      lineHeight: '20px',
      letterSpacing: '0em'
    }),
    subtitle1: _objectSpread(_objectSpread({}, typographyMixin), {}, {
      fontWeight: 400,
      fontSize: '16px',
      lineHeight: '23px',
      letterSpacing: '0em'
    }),
    subtitle2: _objectSpread(_objectSpread({}, typographyMixin), {}, {
      fontWeight: 500,
      fontSize: '14px',
      lineHeight: '23px',
      letterSpacing: '0em'
    }),
    button: _objectSpread(_objectSpread({}, typographyMixin), {}, {
      fontWeight: 500,
      fontSize: '16px',
      lineHeight: '19px',
      letterSpacing: '0em',
      textTransform: 'none'
    }),
    caption: _objectSpread(_objectSpread({}, typographyMixin), {}, {
      fontWeight: 400,
      fontSize: '12px',
      lineHeight: '14px',
      letterSpacing: '0em'
    }),
    overline: _objectSpread(_objectSpread({}, typographyMixin), {}, {
      fontWeight: 500,
      fontSize: '12px',
      lineHeight: '14px',
      letterSpacing: '0em',
      textTransform: 'none'
    })
  },
  palette: {
    common: {
      black: '#000',
      white: '#fff'
    },
    text: {
      primary: '#333333',
      // rgb(51,51,51)
      secondary: '#737373',
      // rgb(115,115,115)
      disabled: '#8a8a8a' // rgb(138,138,138)

    },
    grey: (_grey = {}, _defineProperty(_grey, '50', '#fafafa'), _defineProperty(_grey, '100', '#efefef'), _defineProperty(_grey, '200', '#e8e8e8'), _defineProperty(_grey, '300', '#d3d3d3'), _defineProperty(_grey, '400', '#bababa'), _defineProperty(_grey, '500', '#8a8a8a'), _defineProperty(_grey, '600', '#737373'), _defineProperty(_grey, '700', '#4d4d4d'), _defineProperty(_grey, '800', '#333333'), _defineProperty(_grey, '900', '#191919'), _grey),
    primary: {
      main: baseColor.primaryMain,
      // #0066cc rgb(0,102,204)
      light: (0, _utils.hexMixColor)('#fff', baseColor.primaryMain, 0.5),
      // 50% of main = #80b3e6 rgb(128,179,230)
      lighter: (0, _utils.hexMixColor)('#fff', baseColor.primaryMain, 0.25),
      // 25% of main = #bfd9f2 rgb(191,217,242)
      lighterPlus: (0, _utils.hexMixColor)('#fff', baseColor.primaryMain, 0.12),
      // 12.1% of main = #e0ecf9 rgb(191,217,242)
      lightest: (0, _utils.hexMixColor)('#fff', baseColor.primaryMain, 0.05),
      // 5% of main = #f2f7fc rgb(242,247,252)
      alt: baseColor.primaryAlt,
      // #a5d2ff rgb(165,210,255)
      altLight: (0, _utils.hexMixColor)('#fff', baseColor.primaryAlt, 0.5),
      // 50% of main = #d2e9ff rgb(210,233,255)
      altLighter: (0, _utils.hexMixColor)('#fff', baseColor.primaryAlt, 0.25),
      // 25% of main = #e9f4ff rgb(233,244,255)
      dark: (0, _utils.hexMixColor)('#000', baseColor.primaryMain, 0.7),
      // 30% darken main = #00478f rgb(0,71,143)
      contrastText: '#fff'
    },
    secondary: {
      main: baseColor.secondaryMain,
      // #00925b rgb(0,146,91)
      light: (0, _utils.hexMixColor)('#fff', baseColor.secondaryMain, 0.5),
      // 50% of main = #80c9ad rgb(128,201,173)
      lighter: (0, _utils.hexMixColor)('#fff', baseColor.secondaryMain, 0.25),
      // 25% of main = #bfe4d6 rgb(191,228,214)
      lighterPlus: (0, _utils.hexMixColor)('#fff', baseColor.secondaryMain, 0.12),
      // 12.1% of main = #e0f2eb rgb(224,242,235)
      lightest: (0, _utils.hexMixColor)('#fff', baseColor.secondaryMain, 0.05),
      // 5% of main = #f2faf7 rgb(242,250,247)
      alt: baseColor.secondaryAlt,
      // #80c4aa rgb(128,196,170)
      altLight: (0, _utils.hexMixColor)('#fff', baseColor.secondaryAlt, 0.5),
      // 50% of main = #c0e2d5 rgb(192,226,213)
      altLighter: (0, _utils.hexMixColor)('#fff', baseColor.secondaryAlt, 0.25) // 25% of main = #dff0ea rgb(223,240,234)

    },
    success: {
      main: '#00875a',
      // rgb(0,135,90)
      light: '#bfe1d6',
      // rgb(191,225,214)
      dark: '#005f3f',
      // rgb(0,95,63)
      contrastText: '#fff'
    },
    info: {
      main: baseColor.primaryMain,
      // rgb(0,135,90)
      light: (0, _utils.hexMixColor)('#fff', baseColor.primaryMain, 0.5),
      // 50% of main = #80b3e6 rgb(128,179,230)
      dark: (0, _utils.hexMixColor)('#000', baseColor.primaryMain, 0.7),
      // 30% darken main = #00478f rgb(0,71,143)
      contrastText: '#fff'
    },
    warning: {
      main: '#ffc414',
      // rgb(255,196,20)
      light: '#fff0c4',
      // rgb(255,240,196)
      dark: '#b3890e',
      // rgb(179,137,14)
      contrastText: '#333333' // rgb(51,51,51)

    },
    error: {
      main: '#cc0033',
      // rgb(204,0,51)
      light: '#f2bfcc',
      // rgb(242,191,204)
      dark: '#8f0024',
      // rgb(143,0,36)
      contrastText: '#fff'
    },
    complementary: {
      cc01: '#823c0d',
      // rgb(130,60,13)
      cc02: '#d35500',
      // rgb(211,85,0)
      cc03: '#7c095e',
      // rgb(124,9,94)
      cc04: '#530559',
      // rgb(83,5,89)
      cc05: '#033a38',
      // rgb(3,58,56)
      cc06: '#09647a',
      // rgb(9,100,122)
      cc07: '#1e8787',
      // rgb(30,135,135)
      cc08: '#0f7a49',
      // rgb(15,122,73)
      cc09: '#06662d',
      // rgb(6,102,45)
      cc10: '#3f6014',
      // rgb(63,96,20)
      cc11: '#a0470a',
      // rgb(160,71,10)
      cc12: '#e26814',
      // rgb(226,104,20)
      cc13: '#b2046b',
      // rgb(178,4,107)
      cc14: '#6f0575',
      // rgb(111,5,117)
      cc15: '#015c63',
      // rgb(1,92,99)
      cc16: '#0778a5',
      // rgb(7,120,165)
      cc17: '#27b6c1',
      // rgb(39,182,193)
      cc18: '#05ad75',
      // rgb(5,173,117)
      cc19: '#04a548',
      // rgb(4,165,72)
      cc20: '#508419',
      // rgb(80,132,25)
      cc21: '#ad622f',
      // rgb(173,98,47)
      cc22: '#f27314',
      // rgb(242,115,20)
      cc23: '#d60078',
      // rgb(214,0,120)
      cc24: '#8b0e8e',
      // rgb(139,14,142)
      cc25: '#037b84',
      // rgb(3,123,132)
      cc26: '#058ccf',
      // rgb(5,140,207)
      cc27: '#47d6eb',
      // rgb(71,214,235)
      cc28: '#00db99',
      // rgb(0,219,153)
      cc29: '#00bf59',
      // rgb(0,191,89)
      cc30: '#63b221',
      // rgb(99,178,33)
      cc31: '#ba835d',
      // rgb(186,131,93)
      cc32: '#ff9750',
      // rgb(255,151,80)
      cc33: '#e557b3',
      // rgb(229,87,179)
      cc34: '#a254a8',
      // rgb(162,84,168)
      cc35: '#66aaa3',
      // rgb(102,170,163)
      cc36: '#80c7d8',
      // rgb(128,199,216)
      cc37: '#95e3e8',
      // rgb(149,227,232)
      cc38: '#8ceac6',
      // rgb(140,234,198)
      cc39: '#98d8b2',
      // rgb(152,216,178)
      cc40: '#b4d390',
      // rgb(180,211,144)
      cc41: '#e2a77f',
      // rgb(226,167,127)
      cc42: '#ffb380',
      // rgb(255,179,128)
      cc43: '#eaadd8',
      // rgb(234,173,216)
      cc44: '#d395d8',
      // rgb(211,149,216)
      cc45: '#a9d3ce',
      // rgb(169,211,206)
      cc46: '#9bd3dd',
      // rgb(155,211,221)
      cc47: '#bbe9ea',
      // rgb(187,233,234)
      cc48: '#c0f9e2',
      // rgb(192,249,226)
      cc49: '#c3fcd9',
      // rgb(195,252,217)
      cc50: '#dbefc5' // rgb(219,239,197)

    }
  },
  shadows: ['none', // 0dp
  (0, _theme.createShadow)(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0), // 1dp
  (0, _theme.createShadow)(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0), // 2dp
  (0, _theme.createShadow)(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0), // 3dp
  (0, _theme.createShadow)(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), // 4dp
  (0, _theme.createShadow)(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), // 5dp
  (0, _theme.createShadow)(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), // 6dp
  (0, _theme.createShadow)(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), // 7dp
  (0, _theme.createShadow)(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), // 8dp
  (0, _theme.createShadow)(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), // 9dp
  (0, _theme.createShadow)(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), // 10dp
  (0, _theme.createShadow)(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), // 11dp
  (0, _theme.createShadow)(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), // 12dp
  (0, _theme.createShadow)(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), // 13dp
  (0, _theme.createShadow)(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), // 14dp
  (0, _theme.createShadow)(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), // 15dp
  (0, _theme.createShadow)(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), // 16dp
  (0, _theme.createShadow)(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), // 17dp
  (0, _theme.createShadow)(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), // 18dp
  (0, _theme.createShadow)(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), // 19dp
  (0, _theme.createShadow)(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), // 20dp
  (0, _theme.createShadow)(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), // 21dp
  (0, _theme.createShadow)(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), // 22dp
  (0, _theme.createShadow)(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), // 23dp
  (0, _theme.createShadow)(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8) // 24dp
  ],
  overrides: {
    MuiCssBaseline: {
      '@global': {
        /**
         * Embedded default font
         */
        '@font-face': [_theme2.RobotoRegularFont, _theme2.RobotoMediumFont, _theme2.RobotoLightFont, _theme2.RobotoBoldFont],

        /**
         * Scrollbar custom styling
         */
        '::-webkit-scrollbar': {
          width: '18px',
          height: '18px'
        },
        '::-webkit-scrollbar-track': {
          background: 'transparent'
        },
        '::-webkit-scrollbar-thumb': {
          background: '#bababa',
          borderRadius: '18px',
          WebkitBorderRadius: '18px',
          border: '6px solid rgba(0, 0, 0, 0)',
          backgroundClip: 'padding-box'
        },
        '::-webkit-scrollbar-thumb:hover': {
          background: '#737373',
          borderRadius: '18px',
          WebkitBorderRadius: '18px',
          border: '6px solid rgba(0, 0, 0, 0)',
          backgroundClip: 'padding-box'
        },
        '::-webkit-scrollbar-button': {
          width: 0,
          height: 0,
          display: 'none'
        },
        '::-webkit-scrollbar-corner': {
          backgroundColor: 'transparent'
        }
      }
    },
    MuiTouchRipple: {
      root: {
        color: baseColor.primaryAlt
      }
    }
  }
};
exports.rocheThemeOptions = rocheThemeOptions;